import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect, useLocation } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import util from '../../util/util'
import { Message } from '../../component'
import '../../css/messages.scss'
import { constants } from '../../constants'
import { getMessageList } from '../../store/action/callback.action'
import CaseFilter from '../../component/actioncase/actionCase.filter'
import {
  fechactioncase,
  messageSelectBox,
  messageGroupBy,
} from '../../store/action/actioncases.action'
import { messageScope } from '../../util/messagefilter'
import _ from 'lodash'
import { getHelp, pages } from '../../tutorials'
var { ROLE } = constants

const { Table, ActionBar, Filter, Surgeons } = Message

const ONLY_ADMINS = [
  ROLE.ADMIN,
  ROLE.COMPANY_ADMIN,
  ROLE.COMPANY_HEALTHCOACH,
  ROLE.SUPER_ADMIN,
]

const Messages = (props) => {
  let filter = {}
  var tableRef = useRef()
  const [height, setHeight] = useState(610)
  // const [groupby, setGroupby] = useState(false);
  const [filterData, setFilterData] = useState(null)
  const path = useLocation()
  const showSurgs = path.pathname == '/notification' && !props.user?.surgeon

  useEffect(() => {
    filter.customerIds = [props?.customer?._id]
    filter.archived = false

    if (!props.groupby) {
      // fetchActionCases(false);
      // props.messageSelectBox(null)
    }
    //      props.fetchMessages({
    //     surgeonid: props.user.role == ROLE.SURGEON ? props.user.surgeon : undefined,
    //     customer: props.customer._id,
    //     sort: {order: "descend", field: "receivedon"},
    //     pagination: {current: 1,pageSize: 20}
    // }, props.selectedRequests)
    else {
      calculateHeight()
      // fetchActionCases(false);
    }
  }, [props.groupby])

  // useEffect(()=>{
  //  if(!_.isEmpty(props.selectedIndex)){
  //     // setGroupby(true);
  //     props.messageGroupBy(true);
  //  }
  // },[props.selectedIndex])

  useEffect(() => {
    if (!props.groupby) {
      props.messageSelectBox(null)
      fetchActionCases()
    }
  }, [props.groupby])

  useEffect(() => {
    getHelp(pages.MESSAGES)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      calculateHeight()
    }, 0)
  }, [props.requests?.length])

  const calculateHeight = () => {
    if (props.requests?.length == 0) setHeight(500)
    else
      setHeight(
        tableRef.current
          ? tableRef.current.offsetHeight > 350
            ? tableRef.current.offsetHeight
            : 500
          : 610
      )
  }
  const fetchActionCases = async (ischeck = false, surgeonidfilter = false) => {
    if (props.user?.role == constants.ROLE.SURGEON) {
      filter.surgeonId = props.user?.surgeon
    }
    let selectedidx = false
    if (!_.isEmpty(props.selectedIndex) && ischeck) {
      filter.surgeonId = props.selectedIndex
      selectedidx = { key: [props.selectedIndex], row: [] }
    }
    filter = { ...filter, ...props.msgfilter }
    // Always enforce the open customer + message-type scope (defaults to both).
    filter = {
      ...filter,
      ...messageScope({
        customer: props.customer,
        decoded: props.decoded,
      }),
    }
    if (
      surgeonidfilter &&
      !props.groupby &&
      props.currentUserRole != constants.ROLE.SURGEON
    )
      delete filter.surgeonId
    await props.fechactioncase(
      {
        metadata: { current: 1, pageSize: 20 },
        filters: filter,
        sorter: { field: 'lastUpdated', order: 'descend' },
      },
      selectedidx,
      ischeck
    )
  }
  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='messages-container'>
          {/* <Filter/> */}
          <CaseFilter
            setFilterData={setFilterData}
            fetchActionCases={fetchActionCases}
            isMessages
          />
          <ActionBar
            showBtn={showSurgs}
            //  setGroup={setGroupby} groupby={groupby}
          />
          <Row gutter={20} wrap={false}>
            {showSurgs && props.groupby && (
              <Col flex='300px'>
                <Surgeons height={height} />
              </Col>
            )}
            <Col flex='auto'>
              <div ref={tableRef}>
                <Table showSurgs={showSurgs && !props.groupby} />
              </div>
            </Col>
          </Row>
        </Col>
      </Spin>
    </>
  )
}

Messages.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    decoded: util.verifyToken(state.profile.token, true),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    user: state.profile.user,
    successMessage: state.profile.successMessage,
    requests: state.message.requests,
    selectedRequests: state.message.selectedRequests,
    selectedIndex: state.message.selectedIndex,
    groupby: state.message.groupby,
    currentUserRole: state.profile?.user?.role,
    msgfilter: state.message.filter,
    sort: state.message.sort,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // fetchMessages: (filter, selected) => dispatch(getMessageList(filter, selected)),
    fechactioncase: (params) => dispatch(fechactioncase(params)),
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
    messageSelectBox: (data) => dispatch(messageSelectBox(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Messages)
